import React, { useState , useRef} from "react";
import { Link } from "react-router-dom";
import { BackArrowIcon2, Back_img, Brandicon, New_ScrollX2025, Settings, scrollxLogo, scrollx_icon } from "../assets/icons";
import Setting from "../Pages/Setting/Setting";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function Navbar_back_btn() {
   const userInfo = JSON.parse(localStorage.getItem("user"));
    const profileBtnRef = useRef(null);
  const [isSettingOpen, setIsSettingOpen] = useState(false);

  const getBackgroundColor = () => "#7c5cff26";

    const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    if (firstName) return firstName.charAt(0).toUpperCase();
    return "U";
  };

  return (
    <div className="w-full Pro_navbarDash flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl">
      <div className="w-full h-full flex flex-wrap items-center justify-between ">

        <div className="flex items-center gap-3 min-w-0">

          <Link className="arrowIcon flex items-center opacity-30 hover:opacity-100" to="/dashboard"><IoMdArrowRoundBack size={20} /></Link>

          <div className="h-[17px] w-[1px] bg-[#ffffff1a]" />

          <div className="w-full h-full flex items-center gap-2.5 text-sx-ink font-semibold text-[15px] tracking-tight">
            <a href="https://scrollx.io/" className="nav-logo">
              <img className="w-[35px] h-[35px]" src={New_ScrollX2025} alt="ScrollX" />
              <span className="font-body text-[18px]">ScrollX</span>
            </a>
          </div>

        </div>

        <div className="flex justify-center items-center w-[15%]">
          <h1 className=" text-[15px] font-body font-medium">Account Settings</h1>
        </div>

        <div className="w-[15%] flex justify-end items-center">
            <button
              ref={profileBtnRef}
              type="button"
              className="w-[35px] h-[35px] flex justify-center items-center border-[1px] border-[#7c5cff4d] hover:bg-[#7c5cff40] rounded-full transition-colors"
              onClick={() => setIsSettingOpen((open) => !open)}
              style={{ backgroundColor: getBackgroundColor() }}
              aria-expanded={isSettingOpen}
              aria-haspopup="true"
            >
              <div className="flex justify-center items-center text-[#c4b2ff] text-xl font-body w-[35px] h-[35px] rounded-full">
                <span className="font-body text-[#c4b2ff] text-lg text-center">
                  {getUserInitials()}
                </span>
              </div>
            </button>
          </div>
      </div>

      <Setting
              isSettingOpen={isSettingOpen}
              setIsSettingOpen={setIsSettingOpen}
              anchorRef={profileBtnRef}
            />

    </div>
  );
}
